module.exports = {
          srcSet: __webpack_public_path__ + "fe0ce953dec384d0101e6397acf08ba7-293.png"+" 293w",
          images:[ {path: __webpack_public_path__ + "fe0ce953dec384d0101e6397acf08ba7-293.png",width: 293,height: 110}],
          src: __webpack_public_path__ + "fe0ce953dec384d0101e6397acf08ba7-293.png",
          toString:function(){return __webpack_public_path__ + "fe0ce953dec384d0101e6397acf08ba7-293.png"},
          
          width: 293,
          height: 110
        }